module.exports = __webpack_public_path__ + "static/img/DSC_2694.737d48d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2694.jpg
// module id = 277
// module chunks = 0